<template>
	<div id="notifications-view">
		<b-modal :toggle="toggle" fullscreen>
			<div class="notifications-body px-4 py-2">
				<div class="notifications-header level is-mobile">
					<div class="level-left">
						<div class="level-item">
							<p class="title is-4 is-txt-accent-dark">Notificaciones</p>
						</div>
					</div>
					<div class="level-right">
						<div class="level-item">
							<div>
								<span class="close is-size-3 is-txt-accent-dark" @click="onCloseClick"
									>&times;</span
								>
							</div>
						</div>
					</div>
				</div>
				<div class="is-size-7 has-text-left my-2">
					<span v-if="hasPermissionPushNotification">Notificaciones habilitadas. Sincroniza el dispositivo para recibir notificaciones</span>
					<span v-else>Notificaciones inhabilitadas. Permite las notificaciones para poder avisarte las tomas de medición</span>
					<div class="has-text-right my-2">
						<button v-if="hasPermissionPushNotification"
							class="button is-small is-bg-accent"
							@click="getMessagingToken">Sincronizar dispositivo</button>
						<button v-else
							class="button is-small is-bg-accent"
							@click="notificationsPermisionRequest">Habilitar notificationes</button>
					</div>
				</div>
				<div class="notifications-empty" v-if="notifications.length === 0">
					<article class="message is-dark">
						<div class="message-body">No hay notificaciones por el momento</div>
					</article>
				</div>
				<div class="notifications-list" v-else>
					<div
						class="notification-item mb-2 px-2 pt-4 pb-2 is-bg-accent-extra-light"
						:key="'notif' + i"
						v-for="(item, i) in notifications"
					>
						<div class="media">
							<div class="media-left">
									<template v-if="item.type === NotificationType.TAKE_MEDICINE">
										<heart-icon color="primary" class="image is-48x48"></heart-icon>
									</template>
									<template
										v-else-if="item.type === NotificationType.VIDEO_CALL_REQUEST"
									>
										<phone-call-icon color="primary-alt"></phone-call-icon>
									</template>
									<template
										v-else-if="item.type === NotificationType.RECORD_SAVED || item.type === NotificationType.RECORD_SAVED_WARNING || item.type === NotificationType.PATIENT_HIGH_RISK"
									>
										<activity-icon color="accent" class="image is-48x48"></activity-icon>
									</template>
							</div>
							<div
								class="media-content has-text-left is-txt-grey-dark is-size-6"
								@click="onClickNotification(item)"
							>
								<template v-if="item.type === NotificationType.TAKE_MEDICINE">
									Toma medición de tus signos vitales 
								</template>
								<template
									v-else-if="item.type === NotificationType.VIDEO_CALL_REQUEST"
								>
									Tienes una videollamada con el doctor
								</template>
								<template
									v-else-if="item.type === NotificationType.RECORD_SAVED"
								>
									Signos vitales enviados correctamente
								</template>
								<template
									v-else-if="item.type === NotificationType.RECORD_SAVED_WARNING"
								>
									Signos vitales enviados correctamente. Se requiere una posterior medición después de 30 minutos. Se le enviará una notificación.
								</template>
								<template
									v-else-if="item.type === NotificationType.PATIENT_HIGH_RISK"
								>
									Señales emitidos por paciente no están dentro de los límites seguros
								</template>
								- <span class="has-text-weight-semibold is-size-7 is-txt-accent">{{ formatDateTime(item.createdAt) }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script lang="ts">
	import { computed, defineComponent, ref } from "vue";
	import BModal from "./Modal.vue";
	import {
		NNotification,
		NotificationType,
	} from "../domain/entities/NNotification";
	import { pprint } from "@/helpers/pprint";
	import { useRouter } from "vue-router";
	import useNotification from "@/store/NotificationState";
	import HeartIcon from "@/assets/HeartIcon.vue";
	import PhoneCallIcon from "@/assets/PhoneCallIcon.vue";
	import ActivityIcon from "@/assets/ActivityIcon.vue";
	import { formatDateTime } from "@/domain/entities/EntityFields";

	export default defineComponent({
		name: "NotificationsView",
		components: {
			BModal, ActivityIcon, PhoneCallIcon, HeartIcon,
		},
		props: {},
		setup() {
			const {
				notifications : rawNotification,
				hasNewNotifications,
				listenNotifications,
				notificationsPermisionRequest,
				hasPermissionPushNotification,
				getMessagingToken,
			} = useNotification();
			listenNotifications();
			const notifications = computed(() => rawNotification.value)

			let router = useRouter();
			let toggle = ref(false);
			function onCloseClick() {
				toggle.value = false;
				// ctx.emit('on-close-click')
			}
			function open() {
				toggle.value = true;
				hasNewNotifications.value = false;
			}

			async function sendSurvey() {
				// do logic stuff here
				toggle.value = false;
			}
			function onClickNotification(notif: NNotification) {
				if (notif.type === NotificationType.VIDEO_CALL_REQUEST) {
					let code = notif.payload!["id"];
					pprint("code", code);
					router.push({
						name: "call",
						query: {
							id: code,
						},
					});
				}
			}
			
			let icon = {
				activity: require("@/assets/activity.svg"),
				heart: require("@/assets/heart.svg"),
				phoneCall: require("@/assets/phone-call.svg"),
			}
			return {
				toggle,
				onCloseClick,
				notifications,
				NotificationType,
				sendSurvey,
				open,
				onClickNotification,
				icon,
				formatDateTime,
				notificationsPermisionRequest,
				hasPermissionPushNotification,
				getMessagingToken,
			};
		},
	});
</script>
<style lang="stylus" scoped>
	#notifications-view > .modal-content {
		min-height: 100%;
		max-height: none;
	}

	.notifications-body {
		// min-height: 100vh;
		background: white;
	}

	.box {
		box-shadow: none;
		border: 1px solid black;
	}
	svg {
		color red
	}
</style>
